export { default } from './HorizontalScroll';
export { HorizontalScrollProps } from './HorizontalScroll.types';
